<template>
  <div>
    <div
      class="pb-2 flex items-center"
      :class="{'opacity-50': onlyOfflineOption}"
    >
      <input
        v-model="selectedMethod"
        type="radio"
        value="CC"
        class="w-5 h-5"
        :disabled='onlyOfflineOption'
      >
      <label
        class="w-4/5 md:w-auto ml-4 cursor-pointer"
        @click="selectedMethod = 'CC'"
      >
        Credit Card
      </label>
    </div>
    <div
      v-if="selectedMethod === 'CC'"
      class="p-5 border border-dark-b rounded-lg"
    >
      <div class="flex justify-between items-center pb-4">
        <h4 class="font-medium text-lg">Select Card</h4>
        <div class="pt-4 md:pt-0">
        <button
          class="h-12 bg-dark-b px-4 rounded-full"
          @click="showCardModal = true"
        >
          Add new Card
        </button>
      </div>
      </div>
      <div
        v-if="cards.length"
        class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 xl:gap-10"
      >
        <div
          v-for="(card, index) in cards"
          :key="`checkout-card-${index}`"
          class="p-4 border-2 rounded-lg bg-white cursor-pointer hover:shadow-lg"
          :class="{'border-green shadow-lg' :selectedCCId === card.id}"
          @click="selectCard(card.id)"
        >
          <div class="py-5">
            <p>**** **** **** {{ card.last4Digits }}</p>
            <p>{{card.expMonth}} / {{ card.expYear }}</p>
          </div>
          <p class="uppercase font-bold">{{ card.brand }}</p>
        </div>
      </div>
      <div v-else class="p-4">No Card found.</div>
    </div>
    <div
      class="py-2 flex items-center"
      :class="{'opacity-50': onlyOfflineOption}"
    >
      <input
        v-model="selectedMethod"
        type="radio"
        value="ACH"
        class="w-5 h-5"
        :disabled='onlyOfflineOption'
      >
      <label
        class="w-4/5 md:w-auto ml-4 cursor-pointer"
        @click="selectedMethod = 'ACH'"
      >
        ACH
      </label>
    </div>
    <div
      v-if="selectedMethod === 'ACH'"
      class="p-5 border border-dark-b rounded-lg"
    >
      <div class="pb-4">
        <h4 class="font-medium text-lg">Select Account</h4>
      </div>
      <div
        v-if="achs.length"
        class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 xl:gap-10"
      >
        <div
          v-for="(ach, index) in achs"
          :key="`checkout-card-${index}`"
          class="p-4 border-2 rounded-lg bg-white cursor-pointer hover:shadow-lg"
          :class="{'border-green shadow-lg' :selectedACId === ach.id}"
          @click="selectAch(ach.id)"
        >
          <p class="font-bold text-2xl">{{ ach.accountHolderName }}</p>
          <div class="py-5">
            <p>{{ ach.bankName }}</p>
            <p>**** {{ ach.last4 }}</p>
          </div>
        </div>
      </div>
      <div v-else class="px-4">No Account found.</div>
    </div>
    <div class="py-2 flex items-center">
      <input
        v-model="selectedMethod"
        type="radio"
        value="Offline"
        class="w-5 h-5"
      >
      <label
        class="w-4/5 md:w-auto ml-4 cursor-pointer"
        @click="selectedMethod = 'Offline'"
      >
        Offline Payment (connect with our team)
      </label>
    </div>
    <div
      class="py-2 flex items-center"
      :class="{'opacity-50': onlyOfflineOption}"
    >
      <input
        v-model="selectedMethod"
        type="radio"
        value="Trade Finance"
        class="w-5 h-5"
        :disabled='onlyOfflineOption'
      >
      <div class="w-4/5 md:w-auto ml-4">
        <label class="cursor-pointer" @click="selectedMethod = 'Trade Finance'">
          Apply for Trade Finance
        </label>
        <div
          v-if="selectedMethod === 'Trade Finance'"
          class="text-sm opacity-50"
        >
          Our trade finance team will get in touch with you
        </div>
      </div>
    </div>
    <div class="pt-8">
      <h4 class="font-medium text-lg pb-2">Add Govt. Proof ID*</h4>
      <div class="relative border border-dark-b rounded-full inline-block h-12 w-64 bg-white">
        <input
          type="file"
          @change="previewFile"
          class="h-12 opacity-0 z-10 absolute inset-0 w-64"
        >
        <div class="px-5 h-full leading-4 capitalize flex items-center text-dark opacity-50">{{ govtIdProofName }}</div>
      </div>
    </div>
    <NewCardModal
      v-if="showCardModal"
      @close="closeCardModal"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import NewCardModal from '@/shared/components/profile/payment/NewCardModal'
import ProductDetails from '@/shared/mixins/ProductDetails'

export default {
  name: 'PaymentMethodSelection',
  mixins: [ ProductDetails ],
  props: {
    paymentMethod: {
      type: String,
      default: ''
    },
    selectedCardId: {
      default: null
    },
    selectedAchId: {
      default: null
    },
    govtProof: {
      default: null
    },
    hasCustomization: {
      default: false
    },
    totalBill: {
      required: true
    },
    cartProducts: {
      required: true
    }
  },
  data() {
    return {
      cards: [],
      selectedCCId: null,
      showCardModal: false,
      govtIdProof: null,
      achs: [],
      selectedACId: null
    }
  },
  components: {
    NewCardModal
  },
  created() {
    this.fetchInitialData()
    var products = [];
    this.cartProducts.forEach((product) => {
        /*
        window.ga('ec:addProduct', {
          id: product.productId,                            // Transaction ID. Required.
          name: product.name,                       // Product name. Required. 
          sku: product.sku,                        // SKU/code.
          category: product.categoryName,         // Category or variation.
          quantity: product.quantity,
          price : this.calculateItemPrice(product),
          brand: product.brand
        });
        */
        products.push({
          id: product.productId,                            // Transaction ID. Required.
          name: product.name,                       // Product name. Required. 
          sku: product.sku,                        // SKU/code.
          category: product.categoryName,         // Category or variation.
          quantity: product.quantity,
          price : this.calculateItemPrice(product),
          brand: product.brand
        });
    });
    /*
    window.ga('ec:setAction','checkout', {
        'step': 4,                             // A value of 1 indicates this action is first checkout step.
        'option': 'Select Payment Method'      // Used to specify additional info about a checkout stage, e.g. payment method.
    });
    window.ga('send', 'pageview');
    */
    window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			'event': 'checkout',
			'ecommerce': {
				'checkout': {
				'actionField': {'step': 4, 'option': 'Select Payment Method'},
				'products': products
				}
			}
		});
  },
  computed: {
    selectedMethod: {
      get() {
        return this.paymentMethod
      },  
      set(val) {
        let selected = val
        if (this.onlyOfflineOption) {
          selected = 'Offline'
        }
        this.$emit('changeMethod', selected)
      }
    },
    govtIdProofName() {
      return this.govtIdProof ? this.govtIdProof.name : 'Click to Add'
    },
    onlyOfflineOption() {
      return this.hasCustomization || this.totalBill >= 200000
    }
  },
  methods: {
    ...mapActions ([
      'fetchBuyerCards',
      'fetchBuyerACH'
    ]),
    async fetchInitialData() {
      this.selectedCCId = this.selectedCardId
      this.selectedACId = this.selectedAchId
      this.govtIdProof = this.govtProof
      this.cards = await this.fetchBuyerCards()
      this.achs = await this.fetchBuyerACH()
    },
    selectCard(id) {
      if (this.selectedCCId === id) {
        this.selectedCCId = null
      } else {
        this.selectedCCId = id
      }
      this.$emit('cardSelected', this.selectedCCId)
    },
    selectAch(id) {
      if (this.selectedACId === id) {
        this.selectedACId = null
      } else {
        this.selectedACId = id
      }
      this.$emit('achSelected', this.selectedACId)
    },
    closeCardModal(card) {
      this.showCardModal = false
      if (card) {
        this.cards.push(card)
      }
    },
    previewFile(event) {
      if (!event.target.files[0]) return
      this.govtIdProof = event.target.files[0]
      this.$emit('addGovtProof', this.govtIdProof)
    }
  }
}
</script>